import { createFileRoute } from '@tanstack/react-router'
import GtmStartPage from '@/pages/gtm-start'
import { requireAuthenticated } from '@/shared/lib/route-guards'

export const Route = createFileRoute('/$lang/gtm/start/$checkoutId')({
  beforeLoad: ({ context, params, location }) => {
    requireAuthenticated(context, params, location.href)
  },
  component: GtmStartPage,
  staticData: { layout: 'public' },
})
